import React from 'react';
import { ReactComponent as Settings } from '../../assets/img/icons/common/Settings.svg';
import { PageDropdown } from '..';
import './PlayerControls.scss';

const ResolutionDropdownButton = ({ cameraResolution, cameraTooltipKey, container }) => {
  const options = [];
  
  if (cameraResolution.options.length) {
    options.push({ label: 'Quality', header: true });
    options.push(...cameraResolution.options);
  }
  
  return (
    <PageDropdown
      icon={Settings}
      className="player-controls-resolution-dropdown"
      btnClassName="main-video-button main-video-button-resolution"
      direction="top"
      tooltip={{
        id: `camera-tooltip-${cameraTooltipKey}`,
        title: 'Quality',
        place: 'top',
      }}
      options={options.map(item => ({
        label: item.label,
        active: item.value === cameraResolution.resolution,
        header: !!item.header,
        function: !item.header ? () => cameraResolution.onChange(item.value) : undefined,
      }))}
      container={container}
      disabled={!options.length}
      loading={cameraResolution.loading}
    />
  );
};

export default ResolutionDropdownButton;